import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService, LoginResult, AppService, AppSettings } from '../../core';

@Component({
	selector: 'sm-account-login',
	template: require('./sm-account-login.component.html')
})
export class SmAccountLoginComponent implements OnInit {
	@Output('loggedin') onLoggedIn: EventEmitter<LoginResult> = new EventEmitter();

	loginForm: FormGroup;
	loading = false;
	lastActualizationText: string = '';
	termsAndConditionsArticleId: number;
	error: string = null;

	public readonly AUKRO_URL = AppSettings.AUKRO_URL;

	constructor(
		private _authService: AuthService,
		private _fb: FormBuilder,
		private _router: Router,
		private _appService: AppService
	) { }

	/// METHODS

	onSubmitLogin() {
		let self = this;
		if (!self.loading) {
			self.loading = true;
			self.error = null;

			self._authService
				.login(self.loginForm.value.login, self.loginForm.value.password)
				.subscribe(
					result => this.onSuccess(result),
					error => self.error = error.message,
					() => self.loading = false);
		}
	}

	/// LIFECYCLE

	ngOnInit() {
		this.loginForm = this._fb.group({
			'login': ['', Validators.required],
			'password': ['', Validators.required]
		});

		if (this._authService.isLoggedIn()) {
			this._router.navigateByUrl('/sm/transactions');
		}

		this._appService
			.getSettings()
			.subscribe(data => {
				this.lastActualizationText = data.lastActualizationText;
				this.termsAndConditionsArticleId = data.termsAndConditionsArticleId;
			});
	}

	/// PRIVATE METHODS

	private onSuccess(result: LoginResult) {
		if (!result.success) {
			this.error = result.error.replace('AUKRO_URL', this.AUKRO_URL);
		}
		else {
			this.onLoggedIn.emit(result);
			this._router.navigateByUrl('/sm/transactions');
		}
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-account-login.component.ts